/** The platforms the Calendar draws marks for (lower-case, as the marks are named). */
export type Platform = 'tiktok' | 'instagram' | 'youtube' | 'facebook';

export const PLATFORM_NAMES: Record<Platform, string> = {
  tiktok: 'TikTok',
  instagram: 'Instagram',
  youtube: 'YouTube',
  facebook: 'Facebook',
};
